export function setViewUnits() {
    const update = () => {
        document.body.style.setProperty('--1vw', document.documentElement.clientWidth / 100 + 'px')
        document.body.style.setProperty('--1vh', window.innerHeight * 0.01 + 'px')
    }

    update()
    window.addEventListener('resize', update)
}
